export const dapilOptions = [
  { value: 1, label: "BANYUASIN 1 - Banyuasin III, Rantau Bayur, Sembawa" },
  {
    value: 2,
    label:
      "BANYUASIN 2 - Pulau Rimau, Betung, Tungkal Ilir, Suak Tapeh, Selat Penuguan",
  },
  {
    value: 3,
    label:
      "BANYUASIN 3 - Banyuasin II, Muara Telang, Tanjung Lago, Sumber Marga Telang, Karang Agung Ilir",
  },
  {
    value: 4,
    label: "BANYUASIN 4 - Muara Padang, Makarti Jaya, Muara Sugihan, Air Salek",
  },
  { value: 5, label: "BANYUASIN 5 - Banyuasin I, Rambutan, Air Kumbang" },
  { value: 6, label: "BANYUASIN 6 - Talang Kelapa" },
];

export const councilBodyList = [
  { value: 1, label: "pimpinan" },
  { value: 2, label: "bunwas" },
  { value: 3, label: "banggar" },
  { value: 4, label: "badan-kehormatan" },
  { value: 5, label: "bppd" },
  //   { value: 6, label: "bapemperda" },
  { value: 7, label: "anggota" },
];

export const jabatanOptions = [
  { value: "Ketua", label: "Ketua" },
  { value: "Wakil Ketua", label: "Wakil Ketua" },
  { value: "Sekretaris", label: "Sekretaris" },
  { value: "Anggota", label: "Anggota" },
];

export const layout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 6 },
    lg: { span: 5 },
    xl: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 18 },
    lg: { span: 19 },
    xl: { span: 20 },
  },
};
